import React from 'react';
import parse from '../../internals/link-parser';

const Link = props => {
    let { href, query, ...restProps } = props;
    href = parse(href, query);
    return (
        <a href={href} {...restProps}>
            {props.children}
        </a>
    );
};

export default Link;
